var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.615 9.433.44-2.874H6.298V4.694c0-.786.385-1.553 1.62-1.553h1.254V.694S8.034.5 6.947.5c-2.27 0-3.755 1.376-3.755 3.868v2.19H.667v2.875h2.525v6.947a10.152 10.152 0 0 0 3.106 0V9.433h2.317Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;